import moment, { Moment } from 'moment';

export interface DeliveryOrderFilters {
    deliveryDates: Array<Moment | string>;
    clientId?: string | null;
    deliveryRegionId?: string | null;
}

export function buildDeliveryDateFilter(deliveryDates: Array<Moment | string>): string {
    if (deliveryDates.length === 0) {
        throw new Error('At least one delivery date is required.');
    }

    const dateQueryParts: string[] = [];

    deliveryDates.forEach((date) => {
        const deliveryDate = moment(date);

        if (!deliveryDate.isValid()) {
            throw new Error('All delivery dates must be valid.');
        }

        dateQueryParts.push(
            `projectInternalOrders.deliveryDate:${encodeURIComponent(deliveryDate.format('YYYY-MM-DD'))}`,
        );
    });

    return `(${dateQueryParts.join('|')})`;
}

export function buildDeliveryClientFilter(clientId?: string | null): string {
    return clientId ? `(clientId:${encodeURIComponent(clientId)})` : '';
}

export function buildDeliveryRegionFilter(deliveryRegionId?: string | null): string {
    return deliveryRegionId ? `(deliveryRegionId:${encodeURIComponent(deliveryRegionId)})` : '';
}

export function buildDeliveryClientRegionFilter(deliveryRegionId?: string | null): string {
    const filterName = `filter[deliveryRegion.id]`;

    return deliveryRegionId ? `${filterName}=${encodeURIComponent(deliveryRegionId)}` : '';
}

export function buildDeliveryOrdersQuery(filters: DeliveryOrderFilters): string {
    const filterGroups = [
        buildDeliveryDateFilter(filters.deliveryDates),
        buildDeliveryClientFilter(filters.clientId),
        buildDeliveryRegionFilter(filters.deliveryRegionId),
    ].filter(Boolean);

    return `&q=(state:order)^(${filterGroups.join('^')})&page[size]=1000`;
}
